export enum RequirementType {
  COVIDVACCINATION = 400,
  FLUVACCINATION = 45,
}
